import type { NavigateOptions } from '@tanstack/solid-router'

// Маппинг свободных «view»-строк (используются в Rail/Sidebar/Dashboard) в
// абсолютные пути роутера. Историческая совместимость с legacy router.ts —
// оставляем единым словарём, чтобы не дублировать мапинг по callsite'ам.
export type ViewKey =
  | 'dashboard'
  | 'wells'
  | 'files'
  | 'telemetry'
  | 'tasks'
  | 'tools'
  | 'fields'
  | 'casings'
  | 'muds'
  | 'public_states'
  | 'states'
  | 'knbk_assets'
  | 'settings'

export function viewPath(v: string): string {
  switch (v) {
    case 'dashboard':     return '/'
    case 'wells':         return '/wells'
    case 'files':         return '/files'
    case 'telemetry':     return '/telemetry'
    case 'tasks':         return '/tasks'
    case 'tools':         return '/tools'
    case 'fields':        return '/fields'
    case 'casings':       return '/casings'
    case 'muds':          return '/muds'
    case 'public_states': return '/public_states'
    case 'states':        return '/states'
    case 'knbk_assets':   return '/knbk-assets'
    case 'settings':      return '/settings'
    default:              return '/'
  }
}

// view→NavigateOptions; используется AppShell.openView, Dashboard.onOpenView и т.д.
// `as never` — обходим строгую типизацию `to` в tanstack-router (виртуально-узкая
// строка-литерал), мы знаем что viewPath выдаёт валидный для нашего дерева путь.
export function viewNavigate(v: string): NavigateOptions {
  return { to: viewPath(v) as never }
}
